export default {"src":"/_next/static/media/chat-3.bc17a762.svg","height":15,"width":19,"blurWidth":0,"blurHeight":0};